import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { ImageCropperModule } from 'ngx-img-cropper';
import { FooterComponent } from '../components/footer/footer.component';
import { MenuLeftComponent } from '../components/menu-left/menu-left.component';
import { MenuRightComponent } from '../components/menu-right/menu-right.component';
import { TopBarComponent } from '../components/top-bar/top-bar.component';
import { SharedModule } from '../shared/shared.module';
import { SharedComponentsModuleModule } from 'src/app/shared-components-module/shared-components-module.module';
import { ViewSmtpComponent } from '../smtp/view-smtp/view-smtp.component';
import { UINotificationComponent } from '../structure/notifications/notifications-UI.component';
import { AuthGuard } from '../authGuard/auth.guard';

import { AuditTrailModule } from './audit-trail/audit-trail.module';
import { BISModule } from './BIS/biscommunication.module';

import { AgGridModule } from 'ag-grid-angular';
import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey("CompanyName=GovEVA Private Limited,LicensedApplication=Goveva E-Carbon,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-035321,SupportServicesEnd=28_November_2023_[v2]_MTcwMTEyOTYwMDAwMA==f9eba16d2879f28cf7ff6020d0a782d7")

import { ChartsModule } from './charts/charts.module';
import { CompanymasterComponent } from './companymaster/companymaster.component';
import { ComponentsModule } from './components/components.module';
import { DashboardsModule } from './dashboards/dashboards.module';
import { DocumentationModule } from './documentation/documentation.module';
import { EcommerceModule } from './ecommerce/ecommerce.module';
import { InnerFormsModule } from './forms/forms.module';
import { GfmmoduleComponent } from './gfmmodule/gfmmodule.component';
import { GfmDashboardComponent } from './govevaFileManager/gfm-dashboard/gfm-dashboard.component';
import { govevaFileManagerModule } from './govevaFileManager/govevaFileManager.Module';
import { IconsModule } from './icons/icons.module';
import { LayoutModule } from './layout/layout.module';
import { PagesModule } from './pages/pages.module';
import { RoleMasterModule } from './role-master/role-master.module';
import { RolemasterComponent } from './rolemaster/rolemaster.component';
import { StructureComponent } from './structure.component';
import { structureRouting } from './structure.routing';
import { TablesModule } from './tables/tables.module';
import { UserMasterModule } from './user-master/user-master.module';
import { DataImportComponent } from '../data-import/data-import.component';
import { UPSISubscriptionSettingsComponent } from './upsi-subscription-settings/upsi-subscription-settings.component';
import { CreateTrialCompanyComponent } from './trial-subscription/create-trial-company/create-trial-company.component';
import { CreateTrialUserComponent } from './trial-subscription/create-trial-user/create-trial-user.component';
import { TrialUserListFromDcWebsiteComponent } from './trial-subscription/trial-user-list-from-dc-website/trial-user-list-from-dc-website.component';

import { EntityMasterComponent } from './boardEvaluation/entity-master/entity-master.component';
import { EntityMasterService } from '../services/entityMaster.service';
import { RiskEntityMasterService } from '../services/RiskEntityMaster.service';
import { ConfirmationPopupComponent } from './boardEvaluation/confirmation-popup/confirmation-popup.component';
import { EvaluateCategoryComponent } from './boardEvaluation/evaluate-category/evaluate-category.component';
import { EvalCategoryService } from '../services/evalCategory.service';
import { RiskEvalCategoryService } from '../services/riskEvalCategory.service';
import { QuestionMasterBoardEvalComponent } from './boardEvaluation/questionMasterBoardEval/questionMasterBoardEval.component';
import { BoardEvaluationService } from '../services/boardEvaluation.service';
import { RoadmapModuleService } from '../services/roadmapModule.service';
import { BoardEvaluationExecutionService } from '../services/boardEvaluationExecution.service';
import { AssesorsListPopupComponent } from './boardEvaluation/assesors-list-popup/assesors-list-popup.component';
import { ReviewDetailsPopupComponent } from './boardEvaluation/review-details-popup/review-details-popup.component';
import { EvaluationReviewComponent } from './boardEvaluation/evaluation-review/evaluation-review.component';
import { EvaluationFormsComponent } from './boardEvaluation/evaluation-forms/evaluation-forms.component';
import { SummaryReportComponent } from './boardEvaluation/summary-report/summary-report.component';
import { IndividualReportListComponent } from './boardEvaluation/individual-report-list/individual-report-list.component';
import { EvaluationFormListComponent } from './boardEvaluation/evaluation-form-list/evaluation-form-list.component';
import { EvaluationMonitoringComponent } from './boardEvaluation/evaluation-monitoring/evaluation-monitoring.component';
import { EntityFormSetupComponent } from './boardEvaluation/entity-form-setup/entity-form-setup.component';
import { QuestionnaireAssignmentComponent } from './boardEvaluation/questionnaire-assignment/questionnaire-assignment.component';
import { QuestionnaireReviewComponent } from './boardEvaluation/questionnaire-review/questionnaire-review.component';
import { IndividualReportComponent } from './boardEvaluation/individual-report/individual-report.component';
import { EvaluationFormExecutionModule } from './boardEvaluation/evaluation-form-execution/evaluationFormExecutionModule';

import { IssuesListComponent } from './NCD/issues-list/issues-list.component';
import { CreateIssueComponent } from './NCD/create-issue/create-issue.component';
import { TermsheetComponent } from './NCD/termsheet/termsheet.component';
import { EditTermsheetComponent } from './NCD/edit-termsheet/edit-termsheet.component';
import { AllottesLibraryComponent } from './NCD/allottes-library/allottes-library.component';
import { AllottesLibraryListComponent } from './NCD/allottes-library-list/allottes-library-list.component';
import { AlloteesNewComponent } from './NCD/allotees-new/allotees-new.component';
import { UploadTabComponent } from './NCD/upload-tab/upload-tab.component';
import { AdditionalFieldsTabComponent } from './NCD/additional-fields-tab/additional-fields-tab.component';
import { CashflowCalciComponent } from './NCD/cashflow-calci/cashflow-calci.component';
import { AlloteesComponent } from './NCD/allotees/allotees.component';
import { TermsheetLibraryComponent } from './NCD/termsheet-library/termsheet-library.component';
import { RouterModule, Routes } from '@angular/router';
import { AlertComponent } from './alert/alert.component';
import { UpsiemaillogComponent } from './upsi/upsiemaillog/upsiemaillog.component';
import { UpsibulkDataComponent } from './upsi/upsibulk-data/upsibulk-data.component';
import { RecipientUserListComponent } from './upsi/recipient-user-list/recipient-user-list.component';
import { SharerUserListComponent } from './upsi/sharer-user-list/sharer-user-list.component';
import { UpsiemaillogdetailsComponent } from './upsi/upsiemaillogdetails/upsiemaillogdetails.component';
import { AddUpsiDetailsComponent } from './upsi/add-upsi-details/add-upsi-details.component';
import { AddRecipientModalComponent } from './upsi/add-recipient-modal/add-recipient-modal.component';
import { UpsiDetailsListComponent } from './upsi/upsi-details-list/upsi-details-list.component';
import { UpsiRecipientComponent } from './upsi/upsi-recipient/upsi-recipient.component';
import { AddSharerModalComponent } from './upsi/add-sharer-modal/add-sharer-modal.component';
import { UPSISharerComponent } from './upsi/upsi-sharer/upsi-sharer.component';
import { CustomValidation } from '../helpers/customValidation';
import { MeetingsComponent } from './compliance/meetings/meetings.component';
import { AddmeetingComponent } from './compliance/addmeeting/addmeeting.component';
import { AddcircularComponent } from './compliance/addcircular/addcircular.component';
import { AddNewAgendaComponent } from './compliance/add-new-agenda/add-new-agenda.component';
import { AgendaComponent } from './compliance/agenda/agenda.component';
import { AgendaSearchComponent } from './compliance/agenda-search/agenda-search.component';
import { DocxTemplatesComponent } from './compliance/docx-templates/docx-templates.component';
import { CompanytasklistComponent } from './compliance/company-task-list/company-task-list.component';
import { AddTaskComponent } from './compliance/add-task/add-task.component';
import { OnlyNumber } from '../helpers/OnlyNumber';
import { AddgroupComponent } from './compliance/add-group/add-group.component';
import { EditCompanyTasksComponent } from './compliance/edit-company-task/edit-company-task.component';
import { UpdateTaskComponent } from './compliance/update-task/update-task.component';
import { ActivatedCompanyTaskListComponent } from './compliance/activated-company-task-list/activated-company-task-list.component';
import { ActivatedTaskKanbanComponent } from './compliance/activated-task-kanban/activated-task-kanban.component';
import { UpdateActivatedTaskComponent } from './compliance/update-activated-task/update-activated-task.component';
import { AuthAlertComponent } from './auth-alert/auth-alert.component';
import { ProcessComponent } from './compliance/process/process.component';
import { AddNewProcessComponent } from './compliance/add-new-process/add-new-process.component';
import { ActivatedProcessListComponent } from './compliance/activated-process-list/activated-process-list.component';
import { ActivatedProcessTaskComponent } from './compliance/activated-process-task/activated-process-task.component';
import { UpsiMasterComponent } from './master/upsi-master/upsi-master.component';
import { UpsiParamComponent } from './master/upsi-param/upsi-param.component';
import { CompanyFinanceDetailsComponent } from './master/company-finance-details/company-finance-details.component';
import { AddFinanceDetailsComponent } from './master/add-finance-details/add-finance-details.component';
import { UpdateFinanceDetailsComponent } from './master/update-finance-details/update-finance-details.component';
import { CommitteeComponent } from './master/committee/committee.component';
import { CommitteeEditComponent } from './master/committee-edit/committee-edit.component';
import { BranchComponent } from './master/branch/branch.component';
import { DepartmentComponent } from './master/department/department.component';
import { TagComponent } from './master/tag/tag.component';
import { AgendaCategoriesComponent } from './master/agenda-categories/agenda-categories.component';
import { AgendaGroupComponent } from './master/agenda-group/agenda-group.component';
import { EmailReminderComponent } from './master/email-reminder/email-reminder.component';
import { DefaultMeetingListComponent } from './master/default-meeting-list/default-meeting-list.component';
import { DefaultMeetingAddComponent } from './master/default-meeting-add/default-meeting-add.component';
import { UserTeamMasterComponent } from './master/user-team-master/user-team-master.component';
import { HolidayComponent } from './master/holiday/holiday.component';
import { DocumentGenerationMasterSetupComponent } from './master/document-generation-master-setup/document-generation-master-setup.component';
import { EditMasterDocumentComponent } from './master/edit-master-document/edit-master-document.component';
import { DirectorComponent } from './compliance/director/director.component';
import { DirectorAddEditComponent } from './compliance/director-add-edit/director-add-edit.component';
import { KMPDetailsComponent } from './compliance/kmpdetails/kmpdetails.component';
import { KMPAddEditComponent } from './compliance/kmpadd-edit/kmpadd-edit.component';
import { Mgt1listComponent } from './compliance/mgt1list/mgt1list.component';
import { Mgt2listComponent } from './compliance/mgt2list/mgt2list.component';
import { Ben3listComponent } from './compliance/ben3list/ben3list.component';
import { BeneficialOwnerComponent } from './compliance/beneficial-owner/beneficial-owner.component';
import { Sh2ListComponent } from './compliance/sh2/sh2-list/sh2-list.component';
import { Sh2Component } from './compliance/sh2/sh2.component';
import { Sh3Component } from './compliance/sh3/sh3.component';
import { Sh3listComponent } from './compliance/sh3/sh3list/sh3list.component';
import { Sh6Component } from './compliance/sh6/sh6.component';
import { Sh6listComponent } from './compliance/sh6/sh6list/sh6list.component';
import { Sh10Component } from './compliance/sh10/sh10.component';
import { Sh10listComponent } from './compliance/sh10/sh10list/sh10list.component';
import { DepositorDetailsComponent } from './compliance/depositor-details/depositor-details.component';
import { DepositorListComponent } from './compliance/depositor-details/depositor-list/depositor-list.component';
import { Chg7Component } from './compliance/chg7/chg7.component';
import { Chg7listComponent } from './compliance/chg7/chg7list/chg7list.component';
import { Mbp2Component } from './compliance/mbp2/mbp2.component';
import { Mbp2listComponent } from './compliance/mbp2/mbp2list/mbp2list.component';
import { Mbp3Component } from './compliance/mbp3/mbp3.component';
import { Mbp3listComponent } from './compliance/mbp3/mbp3list/mbp3list.component';
import { Mbp4aComponent } from './compliance/mbp4a/mbp4a.component';
import { Mbp4alistComponent } from './compliance/mbp4a/mbp4alist/mbp4alist.component';
import { Mbp4blistComponent } from './compliance/mbp4blist/mbp4blist.component';
import { InspectionComponent } from './compliance/inspection/inspection.component';
import { InspectionlistComponent } from './compliance/inspection/inspectionlist/inspectionlist.component';
import { ProxyComponent } from './compliance/proxy/proxy.component';
import { ProxylistComponent } from './compliance/proxy/proxylist/proxylist.component';
import { MasterBankParticularsComponent } from './compliance/master-bank-particulars/master-bank-particulars.component';
import { Mgt1addComponent } from './compliance/mgt1list/mgt1add/mgt1add.component';
import { Mgt2addComponent } from './compliance/mgt2list/mgt2add/mgt2add.component';
import { BankParticularsComponent } from './compliance/master-bank-particulars/bank-particulars/bank-particulars.component';
import { PowerofattorneylistComponent } from './compliance/powerofattorneylist/powerofattorneylist.component';
import { PowerofattorneyComponent } from './compliance/powerofattorneylist/powerofattorney/powerofattorney.component';
import { PaymentofDividentListComponent } from './compliance/paymentof-divident-list/paymentof-divident-list.component';
import { PaymentofDividentComponent } from './compliance/paymentof-divident-list/paymentof-divident/paymentof-divident.component';
import { InvestmentComponent } from './compliance/investment/investment.component';
import { InvestmentlistComponent } from './compliance/investment/investmentlist/investmentlist.component';
import { EcsComponent } from './compliance/ecs/ecs.component';
import { EcslistComponent } from './compliance/ecs/ecslist/ecslist.component';
import { DocumentundercommonseallistComponent } from './compliance/documentundercommonseallist/documentundercommonseallist.component';
import { CommonsealComponent } from './compliance/documentundercommonseallist/commonseal/commonseal.component';
import { MasterinvestorcomplaintsComponent } from './compliance/masterinvestorcomplaints/masterinvestorcomplaints.component';
import { InvestorComponent } from './compliance/masterinvestorcomplaints/investor/investor.component';
import { DividentmandatelistComponent } from './compliance/dividentmandatelist/dividentmandatelist.component';
import { DividentComponent } from './compliance/dividentmandatelist/divident/divident.component';
import { PostalballotlistComponent } from './compliance/postalballotlist/postalballotlist.component';
import { PostalballotComponent } from './compliance/postalballotlist/postalballot/postalballot.component';
import { LawsnRegulationComponent } from './lawsn-regulation/lawsn-regulation.component';
// import { TreeModule } from 'angular-tree-component';
import { SummernoteComponent } from './master/summernote/summernote.component';
import { AuthoriserectifyComponent } from './compliance/authoriserectify/authoriserectify.component';
import { KmpauthoriserectifyComponentComponent } from './compliance/kmpauthoriserectify-component/kmpauthoriserectify-component.component';
import { TreeModule } from 'angular-tree-component';
import { EmailsLogService } from '../services/emails-log.service';
import { ComplianceItemComponent } from './compliance/compliance-item/compliance-item.component';
import { ComplianceMasterService } from '../services/compliance-master.service';
import { ComplianceCertificateAddComponent } from './compliance/compliance-certificate-add/compliance-certificate-add.component';
import { ComplianceCertificateListComponent } from './compliance/compliance-certificate-list/compliance-certificate-list.component';
import { ActivatedComplianceCertificateListComponent } from './compliance/activated-compliance-certificate-list/activated-compliance-certificate-list.component';
import { ActivatedComplianceCertificateEditComponent } from './compliance/activated-compliance-certificate-edit/activated-compliance-certificate-edit.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { AppDatepickerMaterialComponent } from '../app-datepicker-material/app-datepicker-material.component';
import { UnapprovedTaskListComponent } from '../unapproved-task-list/unapproved-task-list.component';
import { LibraryagendaEditComponent } from './compliance/libraryagenda-edit/libraryagenda-edit.component';
import { RiskAssesorsListPopupComponent } from './risk-evaluation/risk-assesors-list-popup/risk-assesors-list-popup.component';
import { RiskConfirmationPopupComponent } from './risk-evaluation/risk-confirmation-popup/risk-confirmation-popup.component';
import { RiskEntityFormSetupComponent } from './risk-evaluation/risk-entity-form-setup/risk-entity-form-setup.component';
import { RiskEntityMasterComponent } from './risk-evaluation/risk-entity-master/risk-entity-master.component';
import { RiskEvaluateCategoryComponent } from './risk-evaluation/risk-evaluate-category/risk-evaluate-category.component';
import { RiskEvaluationFormListComponent } from './risk-evaluation/risk-evaluation-form-list/risk-evaluation-form-list.component';
import { RiskEvaluationFormsComponent } from './risk-evaluation/risk-evaluation-forms/risk-evaluation-forms.component';
import { RiskEvaluationMonitoringComponent } from './risk-evaluation/risk-evaluation-monitoring/risk-evaluation-monitoring.component';
import { RiskEvaluationReviewComponent } from './risk-evaluation/risk-evaluation-review/risk-evaluation-review.component';
import { RiskIndividualReportComponent } from './risk-evaluation/risk-individual-report/risk-individual-report.component';
import { RiskIndividualReportListComponent } from './risk-evaluation/risk-individual-report-list/risk-individual-report-list.component';
import { RiskQuestionMasterBoardEvalComponent } from './risk-evaluation/risk-question-master-board-eval/risk-question-master-board-eval.component';
import { RiskQuestionnaireAssignmentComponent } from './risk-evaluation/risk-questionnaire-assignment/risk-questionnaire-assignment.component';
import { RiskQuestionnaireReviewComponent } from './risk-evaluation/risk-questionnaire-review/risk-questionnaire-review.component';
import { RiskReviewDetailsPopupComponent } from './risk-evaluation/risk-review-details-popup/risk-review-details-popup.component';
import { RiskSummaryReportComponent } from './risk-evaluation/risk-summary-report/risk-summary-report.component';
import { RiskEvaluationFormExecutionComponent } from './risk-evaluation/risk-evaluation-form-execution/risk-evaluation-form-execution.component';
import { RiskCategorySidebarComponent } from './risk-evaluation/risk-evaluation-form-execution/risk-category-sidebar/risk-category-sidebar.component';
import { RiskViewOverallQuestionsComponent } from './risk-evaluation/risk-evaluation-form-execution/risk-view-overall-questions/risk-view-overall-questions.component';
import { RiskViewQuestionComponent } from './risk-evaluation/risk-evaluation-form-execution/risk-view-question/risk-view-question.component';
import { RiskEvaluationService } from '../services/risk-evaluation.service';
import { RiskEvalutionExecutionService } from '../services/risk-evalution-execution.service';
import { RiskDepartmentComponent } from './risk-evaluation/risk-department/risk-department.component';
import { RiskMatrixComponent } from './risk-evaluation/risk-matrix/risk-matrix.component';
import { ChatbotFabComponent } from './chatbot/chatbot-fab.component';

export const routes: Routes = [
  { path: 'ncdIssuesList', component: IssuesListComponent, outlet: 'structure-outlet' },
  { path: 'ncd-issue/add', component: CreateIssueComponent, outlet: 'structure-outlet' },
  { path: 'ncd-issue/edit/:issueId', component: CreateIssueComponent, outlet: 'structure-outlet' },
  { path: 'termsheetLibrary', component: TermsheetLibraryComponent, outlet: 'structure-outlet' },
  { path: 'allotteesLibrary', component: AllottesLibraryListComponent, outlet: 'structure-outlet' },
  { path: 'userMaster/upsisharer', component: UPSISharerComponent,  outlet: 'structure-outlet' },
  { path: 'userMaster/upsisharer/sharer/add/:sharer', component: AddSharerModalComponent,  outlet: 'structure-outlet' },
  { path: 'userMaster/upsisharer/sharer/edit/:dataArray', outlet: 'structure-outlet',  component: AddSharerModalComponent },
  { path: 'userMaster/upsirecipient', component: UpsiRecipientComponent,  outlet: 'structure-outlet'},
  { path: 'userMaster/upsirecipient/recipientadd', component: AddRecipientModalComponent,  outlet: 'structure-outlet' },
  { path: 'userMaster/upsirecipient/recipient/edit/:recipientId', outlet: 'structure-outlet',  component: AddRecipientModalComponent },
  {path: 'userMaster/upsidetails', component: UpsiDetailsListComponent,  outlet: 'structure-outlet' },
  { path: 'userMaster/upsidetails/upsidetailsadd', component: AddUpsiDetailsComponent,  outlet: 'structure-outlet' },
  { path: 'userMaster/upsidetails/upsidetailsadd/edit/:detailsId', component: AddUpsiDetailsComponent,  outlet: 'structure-outlet' },
  { path :'bulkData/edit/:detailsId',outlet: 'structure-outlet',component:AddUpsiDetailsComponent},
  {path: 'userMaster/upsiemaillogdetails', component: UpsiemaillogdetailsComponent,  outlet: 'structure-outlet'},
  {path: 'userMaster/upsisharer', component: SharerUserListComponent,  outlet: 'structure-outlet' },
  {path: 'userMaster/upsirecipient', component: RecipientUserListComponent,  outlet: 'structure-outlet' },
  { path: 'userMaster/upsibulkdata', component: UpsibulkDataComponent, outlet: 'structure-outlet' },
  { path: 'userMaster/upsiEmailsLog', component: UpsiemaillogComponent, outlet: 'structure-outlet' },
  { path: 'meeting', component: MeetingsComponent, outlet: 'structure-outlet' },
  { path: 'addMeetings', component: AddmeetingComponent, outlet: 'structure-outlet' },
  { path: 'addMeetings/edit/:meetingId', component: AddmeetingComponent, outlet: 'structure-outlet' },
  { path: 'addMeetings/edit/:meetingId/:tab', component: AddmeetingComponent, outlet: 'structure-outlet' },
  { path: 'addCircular', component: AddcircularComponent, outlet: 'structure-outlet' },
  { path: 'addCircular/edit/:meetingId', component: AddcircularComponent, outlet: 'structure-outlet' },
  { path: 'agenda/edit/:agendaId', component: AddNewAgendaComponent, outlet: 'structure-outlet' },
  { path: 'agenda/add', component: AddNewAgendaComponent, outlet: 'structure-outlet' },
  { path: 'agenda', component: AgendaComponent, outlet: 'structure-outlet' },
  { path: 'agendaSearch', component: AgendaSearchComponent, outlet: 'structure-outlet' },
  { path: 'templates', component: DocxTemplatesComponent, outlet: 'structure-outlet' },
  { path: 'libraryTask', component: CompanytasklistComponent, outlet: 'structure-outlet' },
  { path: 'unapprovedLibraryTask', component: UnapprovedTaskListComponent, outlet: 'structure-outlet' },
  { path: 'addTask', component: AddTaskComponent, outlet: 'structure-outlet' },
  { path: 'tasks/editReminderFrequecies', component: EditCompanyTasksComponent, outlet: 'structure-outlet' },
  { path: 'meeting/Libraryagenda/edit/:agendaId', component: LibraryagendaEditComponent, outlet: 'structure-outlet' },
  { path: 'updateTask/:taskId', component: UpdateTaskComponent, outlet: 'structure-outlet' },
  { path: 'tasks/activated', component: ActivatedCompanyTaskListComponent, outlet: 'structure-outlet' },
  { path: 'tasks/activated/kanban', component: ActivatedTaskKanbanComponent, outlet: 'structure-outlet' },
  { path: 'tasks/activated/update/:taskId', component: UpdateActivatedTaskComponent, outlet: 'structure-outlet' },
  { path: 'process', component: ProcessComponent, outlet: 'structure-outlet' },
  { path: 'process/add', component: AddNewProcessComponent, outlet: 'structure-outlet' },
  { path: 'process/edit/:processId', component: AddNewProcessComponent, outlet: 'structure-outlet' },
  { path: 'activatedprocess', component: ActivatedProcessListComponent, outlet: 'structure-outlet' },
  { path: 'process/activatedtasks/:processId', component: ActivatedProcessTaskComponent, outlet: 'structure-outlet' },
  { path: 'upsimaster', component: UpsiMasterComponent, outlet: 'structure-outlet' },
  { path: 'upsiparam', component: UpsiParamComponent, outlet: 'structure-outlet' },
  { path: 'company/financeDetails', component: CompanyFinanceDetailsComponent, outlet: 'structure-outlet' },
  { path: 'company/financeDetails/add', component: AddFinanceDetailsComponent, outlet: 'structure-outlet' },
  { path: 'company/financeDetails/edit/:id', component: UpdateFinanceDetailsComponent, outlet: 'structure-outlet' },
  { path: 'committee', component: CommitteeComponent, outlet: 'structure-outlet' },
  { path: 'committee/edit/:committeeId', component: CommitteeEditComponent, outlet: 'structure-outlet' },
  { path: 'branch', component: BranchComponent, outlet: 'structure-outlet' },
  { path: 'department', component: DepartmentComponent, outlet: 'structure-outlet' },
  { path: 'tag', component: TagComponent, outlet: 'structure-outlet' },
  { path: 'category', component: AgendaCategoriesComponent, outlet: 'structure-outlet' },
  { path: 'agendaGroup', component: AgendaGroupComponent, outlet: 'structure-outlet' },
  { path: 'emailReminderTemplates/:type', component: EmailReminderComponent, outlet: 'structure-outlet' },
  { path: 'defaultMeeting', component: DefaultMeetingListComponent, outlet: 'structure-outlet' },
  { path: 'defaultMeeting/add', component: DefaultMeetingAddComponent, outlet: 'structure-outlet' },
  { path: 'defaultMeeting/edit/:deftMeetingId', component: DefaultMeetingAddComponent, outlet: 'structure-outlet' },
  { path: 'user/team', component: UserTeamMasterComponent, outlet: 'structure-outlet' },
  { path: 'holiday', component: HolidayComponent, outlet: 'structure-outlet' },
  { path: 'ncd/document/generation/mster/setup', component: DocumentGenerationMasterSetupComponent, outlet: 'structure-outlet' },
  { path: 'ncd/document/generation/mster/setup/:id', component: EditMasterDocumentComponent, outlet: 'structure-outlet' },
  { path: 'director', component: DirectorComponent, outlet: 'structure-outlet' },
  { path: 'director/edit/:directorId', component: DirectorAddEditComponent, outlet: 'structure-outlet' },
  { path: 'KMP', component: KMPDetailsComponent, outlet: 'structure-outlet' },
  { path: 'KMP/edit/:kmpId', component: KMPAddEditComponent, outlet: 'structure-outlet' },
  { path: 'mgt1', component: Mgt1listComponent, outlet: 'structure-outlet' },
  { path: 'mgt1/add', component: Mgt1addComponent, outlet: 'structure-outlet' },
  { path: 'mgt1/edit/:particularId', component: Mgt1addComponent, outlet: 'structure-outlet' },
  { path: 'mgt2', component: Mgt2listComponent, outlet: 'structure-outlet' },
  { path: 'mgt2/add', component: Mgt2addComponent, outlet: 'structure-outlet' },
  { path: 'mgt2/edit/:particularId', component: Mgt2addComponent, outlet: 'structure-outlet' },
  { path: 'ben3list', component: Ben3listComponent, outlet: 'structure-outlet' },
  { path: 'beneficial-owner/add', component: BeneficialOwnerComponent, outlet: 'structure-outlet' },
  { path: 'beneficial-owner/edit/:particularId', component: BeneficialOwnerComponent, outlet: 'structure-outlet' },
  { path: 'sh2list', component: Sh2ListComponent, outlet: 'structure-outlet' },
  { path: 'sh-2/add', component: Sh2Component, outlet: 'structure-outlet' },
  { path: 'sh-2/edit/:particularId', component: Sh2Component, outlet: 'structure-outlet' },
  { path: 'sh3list', component: Sh3listComponent, outlet: 'structure-outlet' },
  { path: 'sh-3/add', component: Sh3Component, outlet: 'structure-outlet' },
  { path: 'sh-3/edit/:particularId', component: Sh3Component, outlet: 'structure-outlet' },
  { path: 'sh6list', component: Sh6listComponent, outlet: 'structure-outlet' },
  { path: 'sh-6/add', component: Sh6Component, outlet: 'structure-outlet' },
  { path: 'sh-6/edit/:particularId', component: Sh6Component, outlet: 'structure-outlet' },
  { path: 'sh10list', component: Sh10listComponent, outlet: 'structure-outlet' },
  { path: 'sh-10/add', component: Sh10Component, outlet: 'structure-outlet' },
  { path: 'sh-10/edit/:particularId', component: Sh10Component, outlet: 'structure-outlet' },
  { path: 'depositorList', component: DepositorListComponent, outlet: 'structure-outlet' },
  { path: 'depositordetails/add', component: DepositorDetailsComponent, outlet: 'structure-outlet' },
  { path: 'depositordetails/edit/:particularId', component: DepositorDetailsComponent, outlet: 'structure-outlet' },
  { path: 'chg7List', component: Chg7listComponent, outlet: 'structure-outlet' },
  { path: 'chg7/add', component: Chg7Component, outlet: 'structure-outlet' },
  { path: 'chg7/edit/:particularId', component: Chg7Component, outlet: 'structure-outlet' },
  { path: 'mbp2List', component: Mbp2listComponent, outlet: 'structure-outlet' },
  { path: 'mbp2/add', component: Mbp2Component, outlet: 'structure-outlet' },
  { path: 'mbp2/edit/:particularId', component: Mbp2Component, outlet: 'structure-outlet' },
  { path: 'mbp3List', component: Mbp3listComponent, outlet: 'structure-outlet' },
  { path: 'mbp3/add', component: Mbp3Component, outlet: 'structure-outlet' },
  { path: 'mbp3/edit/:particularId', component: Mbp3Component, outlet: 'structure-outlet' },
  { path: 'mbp4aList', component: Mbp4alistComponent, outlet: 'structure-outlet' },
  { path: 'mbp4a/add', component: Mbp4aComponent, outlet: 'structure-outlet' },
  { path: 'mbp4a/edit/:particularId', component: Mbp4aComponent, outlet: 'structure-outlet' },
  { path: 'mbp4bList', component: Mbp4blistComponent, outlet: 'structure-outlet' },
  { path: 'inspectionList',  component: InspectionlistComponent, outlet: 'structure-outlet'  },
  { path: 'inspection/add', component: InspectionComponent, outlet: 'structure-outlet'  },
  { path: 'inspection/edit/:particularId',  component: InspectionComponent, outlet: 'structure-outlet'  },
  { path: 'proxyList', outlet: 'structure-outlet' , component: ProxylistComponent },
  { path: 'proxy/add', outlet: 'structure-outlet' , component: ProxyComponent },
  { path: 'proxy/edit/:proxyId', outlet: 'structure-outlet' , component: ProxyComponent },
  { path: 'masterbankparticulars', outlet: 'structure-outlet', component: MasterBankParticularsComponent },
  { path: 'bankparticulars/add', outlet: 'structure-outlet', component: BankParticularsComponent },
  { path: 'bankparticulars/edit/:particularId', outlet: 'structure-outlet', component: BankParticularsComponent },
  { path: 'powerofattorney/add', outlet: 'structure-outlet', component: PowerofattorneyComponent },
  { path: 'powerofattorney/edit/:particularId', outlet: 'structure-outlet', component: PowerofattorneyComponent },
  { path: 'powerofattorneylist', outlet: 'structure-outlet', component: PowerofattorneylistComponent },
  { path: 'paymentOfDividendList', outlet: 'structure-outlet', component: PaymentofDividentListComponent },
  { path: 'paymentOfDividend/add', outlet: 'structure-outlet', component: PaymentofDividentComponent },
  { path: 'paymentOfDividend/edit/:particularId', outlet: 'structure-outlet', component: PaymentofDividentComponent },
  { path: 'investment-list', outlet: 'structure-outlet', component: InvestmentlistComponent },
  { path: 'investment/add', outlet: 'structure-outlet', component: InvestmentComponent },
  { path: 'investment/edit/:particularId', outlet: 'structure-outlet', component: InvestmentComponent },
  { path: 'ecslist',  outlet: 'structure-outlet', component: EcslistComponent },
  { path: 'ecs/add',  outlet: 'structure-outlet', component: EcsComponent },
  { path: 'ecs/edit/:particularId',  outlet: 'structure-outlet', component: EcsComponent },
  { path: 'documentundercommonseallist', outlet: 'structure-outlet', component: DocumentundercommonseallistComponent },
  { path: "commonSeal/add", outlet: 'structure-outlet', component: CommonsealComponent },
  { path: 'commonSeal/edit/:particularId', outlet: 'structure-outlet', component: CommonsealComponent },
  { path: 'masterinvestorcomplaints',  outlet: 'structure-outlet', component: MasterinvestorcomplaintsComponent },
  { path: 'investor/add',  outlet: 'structure-outlet', component: InvestorComponent },
  { path: 'investor/edit/:particularId',  outlet: 'structure-outlet', component: InvestorComponent },
  { path: 'dividendMandateList',outlet: 'structure-outlet', component: DividentmandatelistComponent },
  { path: 'dividendMandate/add', outlet: 'structure-outlet', component: DividentComponent },
  { path: 'dividendMandate/edit/:particularId', outlet: 'structure-outlet', component: DividentComponent },
  { path: 'postallballotlist', outlet: 'structure-outlet', component: PostalballotlistComponent },
  { path: 'postalballot/add', outlet: 'structure-outlet', component: PostalballotComponent },
  { path: 'postalballot/edit/:particularId', outlet: 'structure-outlet', component: PostalballotComponent },
  { path: 'compliance',  outlet: 'structure-outlet', component: LawsnRegulationComponent },
  { path: 'summernote/:emailReminderId',  outlet: 'structure-outlet', component: SummernoteComponent },
  { path: 'register/edit/:directorId/:authrectify',  outlet: 'structure-outlet', component: AuthoriserectifyComponent },
  { path: 'registerKMP/edit/:kmpId/:authrectify', outlet: 'structure-outlet', component: KmpauthoriserectifyComponentComponent },
  //compliance certificate
  { path: 'complianceItem',  outlet: 'structure-outlet', component: ComplianceItemComponent },
  { path: 'complianceCertificateList',  outlet: 'structure-outlet', component: ComplianceCertificateListComponent },
  { path: 'activatedComplianceCertificate',  outlet: 'structure-outlet', component: ActivatedComplianceCertificateListComponent },
  { path: 'activatedComplianceCertificate/edit/:id', outlet: 'structure-outlet',component: ActivatedComplianceCertificateEditComponent },
  { path: 'complianceCertificate/add', outlet: 'structure-outlet',component: ComplianceCertificateAddComponent },
  { path: 'complianceCertificate/edit/:id', outlet: 'structure-outlet',component: ComplianceCertificateAddComponent },
  // { path: 'complianceItem',  outlet: 'structure-outlet', component: ComplianceItemComponent },
     {
      path: 'riskEvaluationFormExecution/:assignedFormId',
      canActivate: [AuthGuard],
      component: RiskEvaluationFormExecutionComponent,
      outlet: 'structure-outlet',
    },
    {
      path: 'riskEvaluationFormExecution',
      canActivate: [AuthGuard],
      component: RiskEvaluationFormExecutionComponent,
      outlet: 'structure-outlet',
    },


];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    DataTablesModule,
    ImageCropperModule,
    SharedComponentsModuleModule,
    EvaluationFormExecutionModule,
    // RiskEvaluationFormExecutionModule,
    RouterModule.forChild(routes),
    TreeModule.forRoot(),
    ChartsModule,
    ComponentsModule,
    DashboardsModule,
    DocumentationModule,
    EcommerceModule,
    InnerFormsModule,
    IconsModule,
    LayoutModule,
    NgbDatepickerModule,
    PagesModule,
    TablesModule,
    RoleMasterModule,
    UserMasterModule,
    structureRouting,
    AgGridModule,
    AuditTrailModule,
    BISModule,
    govevaFileManagerModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule
  ],
  providers: [AuthGuard, DatePipe, AlertComponent, CustomValidation, AuthAlertComponent, Location, EntityMasterService, RiskEntityMasterService, RiskEvalCategoryService , EvalCategoryService, BoardEvaluationService, RoadmapModuleService, BoardEvaluationExecutionService, RiskEvaluationService, EmailsLogService,ComplianceMasterService,RiskEvalutionExecutionService, BoardEvaluationExecutionService],
  declarations: [
    OnlyNumber,
    CompanymasterComponent,
    RolemasterComponent,
    UINotificationComponent,
    TopBarComponent,
    MenuLeftComponent,
    AppDatepickerMaterialComponent,
    MenuRightComponent,
    FooterComponent,
    StructureComponent,
    GfmmoduleComponent,
    GfmDashboardComponent,
    ViewSmtpComponent,
    DataImportComponent,
    UPSISubscriptionSettingsComponent,
    EntityMasterComponent,
    ConfirmationPopupComponent,
    EvaluateCategoryComponent,
    EvaluationReviewComponent,
    RiskViewQuestionComponent,
    RiskViewOverallQuestionsComponent,
    RiskCategorySidebarComponent,
    
    QuestionMasterBoardEvalComponent,
    AssesorsListPopupComponent,

    AlertComponent,
    ViewSmtpComponent,
    DataImportComponent,
    IssuesListComponent,
    CreateIssueComponent,
    TermsheetComponent,
    EditTermsheetComponent,
    CashflowCalciComponent,
    AdditionalFieldsTabComponent,
    AlloteesComponent,
    UploadTabComponent,
    AlloteesNewComponent,
    TermsheetLibraryComponent,
    AllottesLibraryListComponent,
    CreateTrialCompanyComponent,
    CreateTrialUserComponent,
    TrialUserListFromDcWebsiteComponent,
    AllottesLibraryComponent,
    UPSISharerComponent, UpsiRecipientComponent, UpsiDetailsListComponent, AddUpsiDetailsComponent,
    AddSharerModalComponent, AddRecipientModalComponent, UpsiemaillogdetailsComponent,
    SharerUserListComponent, RecipientUserListComponent, UpsibulkDataComponent, UpsiemaillogComponent,
    MeetingsComponent,
    AddmeetingComponent,
    AddcircularComponent,
    AddNewAgendaComponent,
    AgendaComponent,
    AgendaSearchComponent,
    DocxTemplatesComponent,
    CompanytasklistComponent,
    AddTaskComponent,
    AddgroupComponent,
    EditCompanyTasksComponent,
    UpdateTaskComponent,
    ActivatedCompanyTaskListComponent,
    ActivatedTaskKanbanComponent,
    UpdateActivatedTaskComponent,
    ProcessComponent,
    AddNewProcessComponent,
    ActivatedProcessListComponent,
    ActivatedProcessTaskComponent,
    UpsiMasterComponent,
    UpsiParamComponent,
    CompanyFinanceDetailsComponent,
    AddFinanceDetailsComponent,
    UpdateFinanceDetailsComponent,
    CommitteeComponent,
    CommitteeEditComponent,
    BranchComponent,
    DepartmentComponent,
    TagComponent,
    AgendaCategoriesComponent,
    AgendaGroupComponent,
    EmailReminderComponent,
    DefaultMeetingListComponent,
    DefaultMeetingAddComponent,
    UserTeamMasterComponent,
    HolidayComponent,
    DocumentGenerationMasterSetupComponent,
    EditMasterDocumentComponent,
    DirectorComponent,
    DirectorAddEditComponent,
    KMPDetailsComponent,
    KMPAddEditComponent,
    Mgt1listComponent,
    Mgt1addComponent,
    Mgt2listComponent,
    Mgt2addComponent,
    Ben3listComponent,
    BeneficialOwnerComponent,
    Sh2ListComponent,
    Sh2Component,
    Sh3Component,
    Sh3listComponent,
    Sh6Component,
    Sh6listComponent,
    Sh10Component,
    Sh10listComponent,
    DepositorDetailsComponent,
    DepositorListComponent,
    Chg7Component,
    Chg7listComponent,
    Mbp2Component,
    Mbp2listComponent,
    Mbp3Component,
    Mbp3listComponent,
    Mbp4aComponent,
    Mbp4alistComponent,
    Mbp4blistComponent,
    InspectionComponent,
    InspectionlistComponent,
    ProxyComponent,
    ProxylistComponent,
    MasterBankParticularsComponent,
    BankParticularsComponent,
    PowerofattorneylistComponent,
    PowerofattorneyComponent,
    PaymentofDividentListComponent,
    PaymentofDividentComponent,
    InvestmentComponent,
    InvestmentlistComponent,
    EcsComponent,
    EcslistComponent,
    DocumentundercommonseallistComponent,
    CommonsealComponent,
    DividentmandatelistComponent,
    DividentComponent,
    PostalballotlistComponent,
    PostalballotComponent,
    MasterinvestorcomplaintsComponent,
    InvestorComponent,
    LawsnRegulationComponent,
    SummernoteComponent,
    AuthoriserectifyComponent,
    KmpauthoriserectifyComponentComponent,
    // GfmPopupforShareComponent,
    ReviewDetailsPopupComponent,
    EvaluationFormsComponent,
    EvaluationMonitoringComponent,
    QuestionnaireAssignmentComponent,
    // QuestionnaireReviewComponent,
    // IndividualReportListComponent,
    //EvaluationMonitoringComponent,
    //IndividualReportComponent,
    EvaluationFormListComponent,
    IndividualReportListComponent,
    IndividualReportComponent,
    SummaryReportComponent,
    QuestionnaireReviewComponent,
    //EvaluationFormsComponent,
    //EvaluationReviewComponent,
    //EvaluationFormToAssignComponent,
    EntityFormSetupComponent,
    //EntityMasterComponent,
    //EvaluateCategoryComponent,
    //RoadmapReviewerComponent,
    //SafeHtmlPipe
    ComplianceItemComponent,
    ComplianceCertificateListComponent,
    ActivatedComplianceCertificateListComponent,
    ActivatedComplianceCertificateEditComponent,
    ComplianceCertificateAddComponent,
    LibraryagendaEditComponent,
    RiskAssesorsListPopupComponent,
    RiskConfirmationPopupComponent,
    RiskEntityFormSetupComponent,
    RiskEntityMasterComponent,
    RiskEvaluateCategoryComponent,
    RiskDepartmentComponent,
    RiskMatrixComponent,
    RiskEvaluationFormListComponent,
    RiskEvaluationFormsComponent,
    RiskEvaluationMonitoringComponent,
    RiskEvaluationReviewComponent,
    RiskIndividualReportComponent,
    RiskIndividualReportListComponent,
    RiskQuestionMasterBoardEvalComponent,
    RiskQuestionnaireAssignmentComponent,
    RiskQuestionnaireReviewComponent,
    RiskReviewDetailsPopupComponent,
    RiskSummaryReportComponent,
    RiskEvaluationFormExecutionComponent,
    RiskViewQuestionComponent,
    RiskViewOverallQuestionsComponent,
    RiskCategorySidebarComponent,
    RiskMatrixComponent,
    ChatbotFabComponent
  ],
  exports: [AppDatepickerMaterialComponent],
  entryComponents: [],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class StructureModule {
  constructor() { }
}
